import React from 'react'
import {UNIT_OF_BUSINESS_SCHEDULE} from '../../../../CodeMaster'
import styled from 'styled-components'
import {NotReRendering} from '../../../../CommonConstants'

interface Props {
    businessScheduleUnit: UNIT_OF_BUSINESS_SCHEDULE
    hours: number[]
    pixelPer1Minute: number
}

const TimeTableViewBackground: React.FC<Props> = React.memo(props => {

    return (<>
        <MinutesBoxNoBorder
            pixelPer1Minute={props.pixelPer1Minute}
        />
        {
            props.hours
                .filter((item, index) => {
                    const acceptOtherThanTheFirstItem: boolean = (index !== 0)
                    return acceptOtherThanTheFirstItem
                })
                .map((hour, index) => {
                    return (
                        <div key={`${props.businessScheduleUnit}-${index}`}>
                            <MinutesBox
                                pixelPer1Minute={props.pixelPer1Minute}
                            />
                            <MinutesBoxGrayBorder
                                pixelPer1Minute={props.pixelPer1Minute}
                            />
                        </div>)
                })
        }
        <MinutesBox
            pixelPer1Minute={props.pixelPer1Minute}
        />
    </>)
}, () => NotReRendering)

export const MinutesBox = styled.div<{pixelPer1Minute: number}>`
          display: flex;
          align-content: center;
          align-items: center;
          border-top: 1px solid #D3D3D3;
          ${props =>
            `height: calc(30px * ${props.pixelPer1Minute});`
          }
    `
export const MinutesBoxGrayBorder = styled(MinutesBox)`
          border-top: 1px solid #F1F1F1;
        `
export const MinutesBoxNoBorder = styled(MinutesBox)`
          border-top: none;
        `

TimeTableViewBackground.displayName = 'TimeTableViewBackground'
export default TimeTableViewBackground
